import { Injectable } from '@angular/core';
import { B2BUnitDetails } from '@shared/models/b2b-unit-details.model';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';

/** Full address entry — includes billing-client fields alongside standard address fields. */
export interface AllB2BUnitAddress {
  streetname?: string;
  streetnumber?: string;
  complement?: string;
  district?: string;
  town?: string;
  region?: string;
  country?: string;
  postalcode?: string;
  shippingAddress?: boolean;
  addressUsage?: string;
  b2bUnitUID?: string;
}

/**
 * Full B2BUnit record stored in `all_b2bunits`.
 * Extends B2BUnitDetails with hierarchy + full addresses list (including billing fields).
 */
export interface AllB2BUnitItem extends B2BUnitDetails {
  childUnits: { uid: string }[];
  rawAddresses: AllB2BUnitAddress[];
}

/**
 * Persists all B2BUnits with complete data + hierarchy + full addresses.
 * Single source of truth replacing:
 *  - `b2b_unit_details` (CurrentB2BUnit)
 *  - `all_b2bunits_hierarchy` (AllB2BUnitsHierarchy)
 *  - `b2bunit_addresses` (AllB2BUnitAddresses)
 *
 * Store: `all_b2bunits` | keyPath: `uid`
 */
@Injectable({ providedIn: 'root' })
export class B2BUnitHierarchyRepository extends RepositoryBase<AllB2BUnitItem> {
  protected readonly KEY_PATH = 'all_b2bunits';
}
